import { ProjectActions } from '@octopus-do/octopus-project-core'

import { InitialTabId } from '../tabs'
import { initialSections, MainSection } from './initialSections'

export const InitSectionsAction = ProjectActions.sections.add({
  items: initialSections,
  index: 0,
  parents: [InitialTabId],
})

export const InitMainSectionAction = ProjectActions.sections.add({
  items: [MainSection],
  index: 0,
  parents: [InitialTabId],
})
